import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { CSSTransition } from "react-transition-group";
import { AppMenu } from "./AppMenu";
import { ShiftStatusBadge } from "./components/ShiftStatusBadge";

export const AppTopbar = (props) => {
    const name = localStorage.getItem("user");
    const role = localStorage.getItem("role");
    const [addressCopied, setAddressCopied] = useState(false);

    const shippingAddress = "1470 Lee Wagener Blvd #101, Fort Lauderdale, FL 33315";

    const copyToClipboard = () => {
        navigator.clipboard.writeText(shippingAddress).then(() => {
            setAddressCopied(true);
            setTimeout(() => setAddressCopied(false), 2000);
        });
    };

    return (
        <>
            <Helmet>
                <link id="theme-link" rel="stylesheet" href="/assets/themes/lara-light-indigo/theme.css" />
            </Helmet>
            <div className="layout-topbar">
                <button
                    type="button"
                    className="p-link layout-menu-button layout-topbar-button"
                    aria-label={props.mobileTopbarMenuActive ? "Close navigation menu" : "Open navigation menu"}
                    aria-expanded={!!props.mobileTopbarMenuActive}
                    onClick={props.onMobileTopbarMenuClick}
                >
                    <i className={props.mobileTopbarMenuActive ? "pi pi-times" : "pi pi-bars"} />
                </button>

                <Link to="/" className="layout-topbar-logo">
                    <img
                        src={props.layoutColorMode === "light" ? "https://res.cloudinary.com/dwxqg9so3/image/upload/v1758210476/4wd_logo_big_croped_djegsi.jpg" : "https://res.cloudinary.com/dwxqg9so3/image/upload/v1758210476/4wd_logo_big_croped_djegsi.jpg"}
                        style={{ height: "70px", width: "auto", objectFit: "cover" }}
                        alt="logo"
                    />
                </Link>

                {/* Desktop Shipping Address - Middle Section */}
                {window.innerWidth > 768 && (
                    <div className="shipping-address-desktop">
                        <div className="address-container" onClick={copyToClipboard} title="Click to copy address">
                            <i className="pi pi-map-marker" style={{ color: "white", marginRight: "8px" }}></i>
                            <span className="address-text">{addressCopied ? "Address Copied!" : `Your US Shipping Address: ${shippingAddress}`}</span>
                            <i className="pi pi-copy" style={{ color: "white", marginLeft: "8px", fontSize: "12px" }}></i>
                        </div>
                    </div>
                )}

                <div className="search_div"></div>

                <ShiftStatusBadge />

                <div className="user_info">
                    <img src="https://res.cloudinary.com/dwxqg9so3/image/upload/v1757928614/4wd_logo_irbmwb.jpg" alt="profile_img" style={{ height: "40px", width: "40px", objectFit: "cover", borderRadius: "50%", border: "1px solid white" }} />
                    <div className="p_div">
                        <p className="p1" style={{ color: "white" }}>
                            {name}
                        </p>
                        <p className="p2">{role}</p>
                    </div>
                </div>

                <button type="button" className="p-link layout-topbar-button mobile-logout-btn" aria-label="Logout" onClick={props.onSignout}>
                    <i className="pi pi-sign-out" />
                </button>
            </div>

            {/* Mobile Shipping Address - Below Main Topbar */}
            {window.innerWidth <= 768 && (
                <div className="shipping-address-mobile">
                    <div className="mobile-address-container" onClick={copyToClipboard} title="Click to copy address">
                        <i className="pi pi-map-marker" style={{ color: "white", marginRight: "8px" }}></i>
                        <span className="mobile-address-text">{addressCopied ? "Address Copied!" : `Your US Shipping Address: ${shippingAddress}`}</span>
                        <i className="pi pi-copy" style={{ color: "white", marginLeft: "8px", fontSize: "12px" }}></i>
                    </div>
                </div>
            )}

            {/* Mobile/tablet navigation - drops down from under the topbar,
                sharing the same grouped/dropdown menu model as the desktop
                sidebar (props.menu comes from App.js's getMenu()). */}
            <CSSTransition classNames="mobile-nav" timeout={220} in={!!props.mobileTopbarMenuActive} unmountOnExit>
                <div className="mobile-nav-overlay">
                    <div className="mobile-nav-backdrop" onClick={props.onMobileTopbarMenuClick} />
                    <div className="mobile-nav-panel" onClick={props.onMobileSubTopbarMenuClick}>
                        <AppMenu model={props.menu} onMenuItemClick={props.onMenuItemClick} />
                    </div>
                </div>
            </CSSTransition>
        </>
    );
};
